const Activities = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-activities"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-activities"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m4 8a4 4 0 1 1 4-4 4 4 0 0 1 -4 4zm3.934.52 10.3 10.3a10.822 10.822 0 0 0 2.642-1.944 10.5 10.5 0 0 0 3.124-7.118 9.412 9.412 0 0 0 -2.735-7.019 9.745 9.745 0 0 0 -11.865-1.348 5.961 5.961 0 0 1 -1.466 7.129zm-1.763 1.066a5.987 5.987 0 0 1 -2.144.414 10.617 10.617 0 0 0 1.054 5 .483.483 0 0 1 -.081.578l-3.718 2.575a3.363 3.363 0 0 0 -1.282 2.413 2.824 2.824 0 0 0 .853 2.151l.445.422a2.948 2.948 0 0 0 2.083.861 3.2 3.2 0 0 0 2.275-1.08l2.744-3.92a.5.5 0 0 1 .6-.119 10.441 10.441 0 0 0 7.2.738z" />
    </svg>
  );
};

export default Activities;
